import { Route, Routes, useNavigate } from 'react-router-dom';
import * as routes from '../constants/Routes';
import { PrivateRoute } from './PrivateRoute';
import { Terms } from '../pages/Terms';
import { Navbar } from '../components/layouts/Navbar';
import { ValidationCode } from '../pages/ValidationCode';
import { Notifications } from '../pages/Notifications';
import { ConfirmRescue } from '../pages/ConfrmRescue';
import { Quiz } from '../pages/Quiz';
import { ChooseInfluencer } from '../pages/ChooseInfluencer';
import { MyBenefits } from '../pages/MyBenefits';
import { Prospects } from '../pages/Prospects';
import { Cart } from '../pages/Cart';
import { RescuesDetails } from '../pages/RescuesDetails';
import { MyRescues } from '../pages/MyRescues';
import { PostValidation } from '../pages/PostValidation';
import { Results } from '../pages/Results';
import { MyIndications } from '../pages/MyIndications';
import { ActionDetails } from '../pages/ActionDetails';
import { RedeemAwards } from '../pages/RedeemAwards';
import { RegisterDetails } from '../pages/RegisterDetails';
import { Infos } from '../pages/Infos';
import { Home } from '../pages/Home';
import { Profile } from '../pages/Profile';
import { Statement } from '../pages/Statement';
import { LandingBusiness } from '../pages/LandingBusiness';
import { Trainings } from '../pages/Trainings';
import { Event } from '../pages/Event';
import {
  InProgressPage,
  PresenceTheme,
  QrPage,
  ResultPage,
} from '../features/presence';
import { Register } from '../pages/Register';
import { KnowledgeTrail } from '../pages/KnowledgeTrail';
import { KnowledgeTrailContent } from '../pages/KnowledgeTrailContent';
import { Action } from '../pages/Action';
import { HomeEquity } from '../features/home-equity/components/HomeEquityLanding/HomeEquityLanding';
import { HomeEquityDetails } from '../features/home-equity/components/HomeEquityDetails/HomeEquityDetails';

export function WithAuth() {
  const navigate = useNavigate();

  if (window.location.pathname === '/') {
    navigate(routes.HOME);
  }

  return (
    <Routes>
      <Route
        path={routes.PROFILE}
        element={
          <PrivateRoute>
            <Navbar>
              <Profile />
            </Navbar>
          </PrivateRoute>
        }
      />
      <Route
        path={routes.EDIT_PROFILE}
        element={
          <PrivateRoute>
            <Navbar>
              <RegisterDetails editing={true} />
            </Navbar>
          </PrivateRoute>
        }
      />
      <Route
        path={routes.HOME}
        element={
          <PrivateRoute>
            <Navbar>
              <Home />
            </Navbar>
          </PrivateRoute>
        }
      />
      <Route
        path={`${routes.INFOS}`}
        element={
          <PrivateRoute>
            <Navbar>
              <Infos />
            </Navbar>
          </PrivateRoute>
        }
      />
      <Route
        path={routes.REGISTER_DETAILS}
        element={
          <PrivateRoute>
            <Navbar>
              <RegisterDetails />
            </Navbar>
          </PrivateRoute>
        }
      />

      <Route path={routes.REGISTER} element={<Register />} />

      <Route
        path={routes.REDEEM_AWARDS}
        element={
          <PrivateRoute>
            <Navbar>
              <RedeemAwards />
            </Navbar>
          </PrivateRoute>
        }
      />
      <Route
        path={`${routes.ACTION_DETAILS}/:actionId`}
        element={
          <PrivateRoute>
            <Navbar>
              <ActionDetails />
            </Navbar>
          </PrivateRoute>
        }
      />
      <Route path={routes.ACTIONS} element={<Action />} />
      <Route
        path={`${routes.EVENT}/:eventId`}
        element={
          <PrivateRoute>
            <Navbar>
              <Event />
            </Navbar>
          </PrivateRoute>
        }
      />
      <Route
        path={`${routes.EVENT}/:eventId/entrada`}
        element={
          <PrivateRoute>
            <Navbar>
              <PresenceTheme>
                <QrPage mode="CHECK_IN" />
              </PresenceTheme>
            </Navbar>
          </PrivateRoute>
        }
      />
      <Route
        path={`${routes.EVENT}/:eventId/permanencia`}
        element={
          <PrivateRoute>
            <Navbar>
              <PresenceTheme>
                <InProgressPage />
              </PresenceTheme>
            </Navbar>
          </PrivateRoute>
        }
      />
      <Route
        path={`${routes.EVENT}/:eventId/saida`}
        element={
          <PrivateRoute>
            <Navbar>
              <PresenceTheme>
                <QrPage mode="CHECK_OUT" />
              </PresenceTheme>
            </Navbar>
          </PrivateRoute>
        }
      />
      <Route
        path={`${routes.EVENT}/:eventId/resultado`}
        element={
          <PrivateRoute>
            <Navbar>
              <PresenceTheme>
                <ResultPage />
              </PresenceTheme>
            </Navbar>
          </PrivateRoute>
        }
      />
      <Route
        path={routes.MY_INDICATIONS}
        element={
          <PrivateRoute>
            <Navbar>
              <MyIndications />
            </Navbar>
          </PrivateRoute>
        }
      />
      <Route
        path={routes.RESULTS}
        element={
          <PrivateRoute>
            <Navbar>
              <Results />
            </Navbar>
          </PrivateRoute>
        }
      />
      <Route
        path={routes.MY_RESCUES}
        element={
          <PrivateRoute>
            <Navbar>
              <MyRescues />
            </Navbar>
          </PrivateRoute>
        }
      />
      <Route
        path={`${routes.RESCUE_DETAILS}/:rescueId`}
        element={
          <PrivateRoute>
            <Navbar>
              <RescuesDetails />
            </Navbar>
          </PrivateRoute>
        }
      />
      <Route
        path={`${routes.POST_VALIDATION}/:publicationId`}
        element={
          <PrivateRoute>
            <Navbar>
              <PostValidation />
            </Navbar>
          </PrivateRoute>
        }
      />

      <Route
        path={routes.CART}
        element={
          <PrivateRoute>
            <Navbar>
              <Cart />
            </Navbar>
          </PrivateRoute>
        }
      />

      <Route
        path={routes.PROSPECTS}
        element={
          <PrivateRoute>
            <Navbar>
              <Prospects />
            </Navbar>
          </PrivateRoute>
        }
      />

      <Route
        path={routes.MY_BENEFITS}
        element={
          <PrivateRoute>
            <Navbar>
              <MyBenefits />
            </Navbar>
          </PrivateRoute>
        }
      />

      <Route
        path={routes.CHOOSE_INFLUENCER}
        element={
          <PrivateRoute>
            <Navbar>
              <ChooseInfluencer />
            </Navbar>
          </PrivateRoute>
        }
      />

      <Route
        path={`${routes.QUIZ}/:actionId`}
        element={
          <PrivateRoute>
            <Navbar>
              <Quiz />
            </Navbar>
          </PrivateRoute>
        }
      />

      <Route
        path={routes.CONFIRM_RESCUE}
        element={
          <PrivateRoute>
            <Navbar>
              <ConfirmRescue />
            </Navbar>
          </PrivateRoute>
        }
      />

      <Route
        path={routes.NOTIFICATIONS}
        element={
          <PrivateRoute>
            <Navbar>
              <Notifications />
            </Navbar>
          </PrivateRoute>
        }
      />

      <Route
        path={routes.VALIDATION_CODE}
        element={
          <PrivateRoute>
            <Navbar>
              <ValidationCode />
            </Navbar>
          </PrivateRoute>
        }
      />

      <Route
        path={routes.STATEMENT}
        element={
          <PrivateRoute>
            <Navbar>
              <Statement />
            </Navbar>
          </PrivateRoute>
        }
      />
      <Route
        path={`${routes.LANDING_BUSSINESS}/:bussinessId/:playerId`}
        element={<LandingBusiness />}
      />
      <Route
        path={`${routes.LANDING_BUSSINESS}/:bussinessId`}
        element={
          <PrivateRoute>
            <Navbar>
              <LandingBusiness />
            </Navbar>
          </PrivateRoute>
        }
      />
      <Route
        path={routes.TRAININGS}
        element={
          <PrivateRoute>
            <Navbar>
              <Trainings />
            </Navbar>
          </PrivateRoute>
        }
      />
      <Route
        path={`${routes.KNOWLEDGE_TRAIL}/:trailId`}
        element={
          <PrivateRoute>
            <Navbar>
              <KnowledgeTrail />
            </Navbar>
          </PrivateRoute>
        }
      />
      <Route
        path={`${routes.KNOWLEDGE_TRAIL}/:trailId/content/:contentIndex`}
        element={
          <PrivateRoute>
            <Navbar>
              <KnowledgeTrailContent />
            </Navbar>
          </PrivateRoute>
        }
      />
      <Route
        path={`${routes.HOME_EQUITY}/:homeEquityId`}
        element={
          <PrivateRoute>
            <Navbar>
              <HomeEquity />
            </Navbar>
          </PrivateRoute>
        }
      />
      <Route
        path={`${routes.HOME_EQUITY_DETAILS}/:homeEquityId`}
        element={
          <PrivateRoute>
            <Navbar>
              <HomeEquityDetails />
            </Navbar>
          </PrivateRoute>
        }
      />
      <Route
        path={`${routes.HOME_EQUITY}/:homeEquityId/:playerId`}
        element={<HomeEquity />}
      />
      <Route path={routes.TERMS} element={<Terms />} />
      <Route
        path="/*"
        element={
          <PrivateRoute>
            <Navbar>
              <Home />
            </Navbar>
          </PrivateRoute>
        }
      />
      <Route path={routes.IFRAME} element={<Register />} />
    </Routes>
  );
}
